import { render, staticRenderFns } from "./PanelCardGroup.vue?vue&type=template&id=b1ea36d2&scoped=true"
import script from "./PanelCardGroup.vue?vue&type=script&lang=js"
export * from "./PanelCardGroup.vue?vue&type=script&lang=js"
import style0 from "./PanelCardGroup.vue?vue&type=style&index=0&id=b1ea36d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ea36d2",
  null
  
)

export default component.exports